export const totemPresencePtBR = {
  "title": "Presença no Totem",
  "description": "Autorize o terminal da portaria e premie a presença com coins.",
  "enable": "Ativar presença com coins",
  "enableDescription": "Desligado por padrão. Ao desativar, a autorização do terminal é revogada.",
  "coins": "Coins por presença",
  "dailyLimit": "Uma bonificação por aluno por dia, mesmo com várias leituras.",
  "timeZone": "Fuso horário da escola",
  "timeZoneDescription": "Define a virada do dia para a bonificação.",
  "save": "Salvar configuração",
  "saved": "Configuração atualizada.",
  "retry": "Tentar novamente",
  "authorized": "Terminal autorizado para registrar presença",
  "approvedAt": "Autorizado em {{date}}",
  "revoke": "Revogar terminal",
  "singleDevice": "Apenas um terminal pode ficar autorizado. Revogue o atual antes de cadastrar outro.",
  "pairTitle": "Autorizar o terminal da escola",
  "step1": "No computador da portaria, abra o SPOT e escolha Totem.",
  "step2": "Entre com o código da unidade e gere o código de pareamento.",
  "step3": "Digite abaixo o código exibido naquele computador e autorize o terminal.",
  "code": "Código exibido no Totem",
  "name": "Nome do terminal",
  "namePlaceholder": "Portaria principal",
  "approve": "Autorizar este Totem",
  "refresh": "Atualizar status e presenças",
  "recent": "Últimas presenças",
  "reward": "+{{coins}} coins",
  "revokeTitle": "Revogar o acesso deste Totem?",
  "revokeDescription": "Este terminal deixará de registrar presenças e conceder coins. Um novo pareamento será necessário para autorizar um terminal.",
  "cancel": "Cancelar",
  "errors": {
    "TOTEM_ADMIN_REQUIRED": "Apenas o responsável ou um administrador da escola pode gerenciar o Totem.",
    "TOTEM_DEVICE_EXISTS": "Já existe um terminal autorizado. Revogue o atual antes de cadastrar outro.",
    "TOTEM_PAIRING_EXPIRED": "O código expirou ou a configuração mudou. Gere outro código no Totem.",
    "TOTEM_DISABLED": "Ative e salve a presença no Totem primeiro.",
    "TOTEM_REVOKED": "O terminal já foi revogado. Atualize o status.",
    "TOTEM_INVALID_INPUT": "Confira os valores. Use coins inteiros de 1 a 10.000 e um fuso horário válido.",
    "TOTEM_UNAVAILABLE": "Não foi possível atualizar o Totem. Tente novamente."
  }
} as const;

export const totemPresenceEnUS = {
  "title": "Kiosk attendance",
  "description": "Authorize the entrance terminal and reward attendance with coins.",
  "enable": "Enable attendance rewards",
  "enableDescription": "Off by default. Disabling this feature revokes the terminal authorization.",
  "coins": "Coins per attendance",
  "dailyLimit": "One reward per student per day, even with repeated scans.",
  "timeZone": "School time zone",
  "timeZoneDescription": "Sets when a new day starts for rewards.",
  "save": "Save configuration",
  "saved": "Configuration updated.",
  "retry": "Try again",
  "authorized": "Terminal authorized to record attendance",
  "approvedAt": "Authorized on {{date}}",
  "revoke": "Revoke terminal",
  "singleDevice": "Only one terminal can be authorized. Revoke the current one before registering another.",
  "pairTitle": "Authorize the school terminal",
  "step1": "On the entrance computer, open SPOT and select Kiosk.",
  "step2": "Enter the school code and generate a pairing code.",
  "step3": "Enter the code shown on that computer below and authorize the terminal.",
  "code": "Code shown on the kiosk",
  "name": "Terminal name",
  "namePlaceholder": "Main entrance",
  "approve": "Authorize this kiosk",
  "refresh": "Refresh status and attendance",
  "recent": "Recent attendance",
  "reward": "+{{coins}} coins",
  "revokeTitle": "Revoke this kiosk?",
  "revokeDescription": "This terminal will no longer record attendance or grant coins. A new pairing will be required to authorize a terminal.",
  "cancel": "Cancel",
  "errors": {
    "TOTEM_ADMIN_REQUIRED": "Only the school owner or an administrator can manage the kiosk.",
    "TOTEM_DEVICE_EXISTS": "A terminal is already authorized. Revoke it before registering another.",
    "TOTEM_PAIRING_EXPIRED": "The code expired or configuration changed. Generate another code on the kiosk.",
    "TOTEM_DISABLED": "Enable and save kiosk attendance first.",
    "TOTEM_REVOKED": "This terminal has already been revoked. Refresh its status.",
    "TOTEM_INVALID_INPUT": "Check the values. Use whole coins from 1 to 10,000 and a valid time zone.",
    "TOTEM_UNAVAILABLE": "Unable to update the kiosk. Try again."
  }
} as const;

export const totemPresenceEsES = {
  "title": "Asistencia en el tótem",
  "description": "Autoriza el terminal de entrada y premia la asistencia con coins.",
  "enable": "Activar premios por asistencia",
  "enableDescription": "Desactivado por defecto. Al desactivarlo se revoca la autorización del terminal.",
  "coins": "Coins por asistencia",
  "dailyLimit": "Un premio por alumno al día, incluso con varias lecturas.",
  "timeZone": "Zona horaria de la escuela",
  "timeZoneDescription": "Define el inicio de un nuevo día para los premios.",
  "save": "Guardar configuración",
  "saved": "Configuración actualizada.",
  "retry": "Reintentar",
  "authorized": "Terminal autorizado para registrar asistencia",
  "approvedAt": "Autorizado el {{date}}",
  "revoke": "Revocar terminal",
  "singleDevice": "Solo puede haber un terminal autorizado. Revoca el actual antes de registrar otro.",
  "pairTitle": "Autorizar el terminal de la escuela",
  "step1": "En el ordenador de la entrada, abre SPOT y selecciona Tótem.",
  "step2": "Introduce el código de la escuela y genera un código de vinculación.",
  "step3": "Introduce abajo el código mostrado en ese ordenador y autoriza el terminal.",
  "code": "Código mostrado en el tótem",
  "name": "Nombre del terminal",
  "namePlaceholder": "Entrada principal",
  "approve": "Autorizar este tótem",
  "refresh": "Actualizar estado y asistencias",
  "recent": "Últimas asistencias",
  "reward": "+{{coins}} coins",
  "revokeTitle": "¿Revocar este tótem?",
  "revokeDescription": "Este terminal dejará de registrar asistencias y conceder coins. Será necesaria una nueva vinculación para autorizar un terminal.",
  "cancel": "Cancelar",
  "errors": {
    "TOTEM_ADMIN_REQUIRED": "Solo el responsable o un administrador de la escuela puede gestionar el tótem.",
    "TOTEM_DEVICE_EXISTS": "Ya hay un terminal autorizado. Revócalo antes de registrar otro.",
    "TOTEM_PAIRING_EXPIRED": "El código caducó o cambió la configuración. Genera otro código en el tótem.",
    "TOTEM_DISABLED": "Activa y guarda primero la asistencia en el tótem.",
    "TOTEM_REVOKED": "El terminal ya fue revocado. Actualiza el estado.",
    "TOTEM_INVALID_INPUT": "Revisa los valores. Usa coins enteros de 1 a 10.000 y una zona horaria válida.",
    "TOTEM_UNAVAILABLE": "No se pudo actualizar el tótem. Inténtalo de nuevo."
  }
} as const;
